import { defaultSitemapObject } from "../sitemap/model/DefaultSitemapObject";
import GlobalDispatchMethods from "../../context/globalDispatchMethods";
import { PageRecord } from "../recordDefinition.types";

const AttributeNames = [
  "cityName",
  "regionName",
  "companyWebsite",
  "customerReferenceFormat",
  "customerReferenceStart",
  "ecommsAgentId",
  "ecommsActivationCode",
  "g4c_customerid",
];

export const quickStartNewRecord: PageRecord = {
  customerReferenceFormat: "{0}",
  customerReferenceStart: 1000000,
};

/** InitialLoad's request: the name, the details, and the default sitemap it creates. */
export function toQuickStartPayload(record: PageRecord) {
  const attributes: Record<string, unknown> = Object.fromEntries(
    AttributeNames.map((name) => [name, record[name] ?? ""])
  );

  // Ticketing reads it as a string before parsing, whatever the number field holds.
  attributes.customerReferenceStart = String(record.customerReferenceStart ?? "");
  attributes.sitemap = defaultSitemapObject;

  return { Name: record.name, Attributes: attributes };
}

/** The navigation builds from the sitemap quick start created, and the initial state is read again. */
export function afterQuickStartSave(_: PageRecord, dispatch: unknown) {
  const globalDispatch = dispatch as (action: Record<string, unknown>) => void;

  globalDispatch({ type: GlobalDispatchMethods.SetSitemap, sitemap: defaultSitemapObject });
  globalDispatch({ type: GlobalDispatchMethods.ResetInitialState });
}
